import React, { useState } from 'react';
const Login = ({
  onLogin
}) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = e => {
    e.preventDefault();
    if (username.trim() === '' || password.trim() === '') {
      setError('Username and password are required');
      return;
    }
    const success = onLogin(username, password);
    if (!success) {
      setError('Invalid username or password');
    }
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-100" data-id="element-310">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md" data-id="element-311">
        <div className="text-center mb-8" data-id="element-312">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-313">
            MemBrain Platform
          </h1>
          <p className="text-gray-600 mt-2" data-id="element-314">Sign in to your account</p>
        </div>
        {error && <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md" data-id="element-315">
            {error}
          </div>}
        <form onSubmit={handleSubmit} data-id="element-316">
          <div className="mb-4" data-id="element-317">
            <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-318">
              Username
            </label>
            <input id="username" type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-319" />
          </div>
          <div className="mb-6" data-id="element-320">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-321">
              Password
            </label>
            <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-322" />
          </div>
          <button type="submit" className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-323">
            Sign In
          </button>
        </form>
      </div>
    </div>;
};
export default Login;